import { providers as providerConfig } from '../config/environment';

const BASE = '/images/providers';

/** Noms de fichiers réels dans public/images/providers (sensible à la casse en prod Linux). */
export const PROVIDER_ICON_FILES = {
    orange: 'orange.png',
    airtel: 'airtel.png',
    africel: 'Africel.png',
    mpesa: 'M-pesa.png',
    netikash: 'netikash.png',
    pay: 'pay.png',
    visa: 'visa.png',
};

const pathFor = (file) => `${BASE}/${file}`;

const BY_PROVIDER_ID = {
    [providerConfig.ORG]: pathFor(PROVIDER_ICON_FILES.orange),
    [providerConfig.RTL]: pathFor(PROVIDER_ICON_FILES.airtel),
    [providerConfig.AFR]: pathFor(PROVIDER_ICON_FILES.africel),
    [providerConfig.VOD]: pathFor(PROVIDER_ICON_FILES.mpesa),
    [providerConfig.NTK]: pathFor(PROVIDER_ICON_FILES.pay),
    [providerConfig.VSA]: pathFor(PROVIDER_ICON_FILES.visa),
};

const BY_NAME = {
    orange: PROVIDER_ICON_FILES.orange,
    'orange money': PROVIDER_ICON_FILES.orange,
    netikash: PROVIDER_ICON_FILES.pay,
    'netikash pay': PROVIDER_ICON_FILES.pay,
    airtel: PROVIDER_ICON_FILES.airtel,
    'airtel money': PROVIDER_ICON_FILES.airtel,
    africel: PROVIDER_ICON_FILES.africel,
    afrimoney: PROVIDER_ICON_FILES.africel,
    'afri money': PROVIDER_ICON_FILES.africel,
    'm-pesa': PROVIDER_ICON_FILES.mpesa,
    'm pesa': PROVIDER_ICON_FILES.mpesa,
    mpesa: PROVIDER_ICON_FILES.mpesa,
    vodafone: PROVIDER_ICON_FILES.mpesa,
    visa: PROVIDER_ICON_FILES.visa,
};

/**
 * Chemin public de l'icône provider (ex. /images/providers/M-pesa.png).
 */
export function getProviderIconPath(providerId, providerName) {
    if (providerId && BY_PROVIDER_ID[providerId]) {
        return BY_PROVIDER_ID[providerId];
    }

    const normalized = String(providerName || '').toLowerCase().trim();
    if (BY_NAME[normalized]) {
        return pathFor(BY_NAME[normalized]);
    }
    if (/m-?\s*pesa|vodafone/i.test(normalized)) {
        return pathFor(PROVIDER_ICON_FILES.mpesa);
    }
    if (/visa/i.test(normalized)) {
        return pathFor(PROVIDER_ICON_FILES.visa);
    }

    return pathFor(PROVIDER_ICON_FILES.netikash);
}

/**
 * URL complète avec PUBLIC_URL (landing, assets statiques).
 */
export function getProviderImageUrl(fileKey) {
    const file = PROVIDER_ICON_FILES[fileKey] || PROVIDER_ICON_FILES.netikash;
    const publicUrl = process.env.PUBLIC_URL || '';
    return `${publicUrl}${pathFor(file)}`;
}

export const LANDING_PROVIDER_BRANDS = [
    { name: 'M-Pesa', src: getProviderImageUrl('mpesa') },
    { name: 'Airtel Money', src: getProviderImageUrl('airtel') },
    { name: 'Orange Money', src: getProviderImageUrl('orange') },
    { name: 'Africell', src: getProviderImageUrl('africel') },
    { name: 'Netikash Pay', src: getProviderImageUrl('netikash') },
];
